export class IaConfiguracaoCliente {
  id: number = 0;
  guidclientenapis: string = "";
  nome_cliente_napis: string = "";
  ia_ativa: boolean = false;
  provider: string = "OPENAI";
  api_key: string = "";
  modelo_ia: string = "gpt-4.1-mini";
  temperatura: number = 0.30;
  max_tokens: number = 800;
  prompt_sistema: string = "";
  prompt_comercial: string = "";
  prompt_chat_geral: string = "";
  prompt_sugestao_produtos: string = "";
  permitir_chat_geral: boolean = true;
  permitir_sugestao_produto: boolean = true;
  is_configurada: boolean = false;
  data_atualizacao: Date = null;
  usuario_atualizacao: string = "";

  /* WhatsApp (Agente IA) */

  permitir_whatsapp: boolean = false;
  prompt_whatsapp_atendimento: string = "";
  whatsapp_modo: string = "DESATIVADO";
  whatsapp_nome_agente: string = "";
  whatsapp_fora_horario_auto: boolean = false;
  whatsapp_usa_emojis: boolean = true;
  whatsapp_se_identifica_ia: boolean = true;
  whatsapp_msg_handoff: string = "";
  whatsapp_silencio_humano_min: number = 30;
  whatsapp_contexto_mensagens: number = 10;
  whatsapp_horario_inicio: string = "";
  whatsapp_horario_fim: string = "";
  whatsapp_dias_semana: string = "";
  whatsapp_handoff_pedido_humano: boolean = true;
  whatsapp_handoff_sentimento: boolean = true;
  whatsapp_handoff_fora_base: boolean = true;
  whatsapp_handoff_negociacao: boolean = true;

  /* Forma de pagamento dos planos no chat: MERCADOPAGO | LINK_DIRETO | DESATIVADO */
  whatsapp_pagamento_tipo: string = "MERCADOPAGO";

  /* Modelo de negocio do agente: PADRAO | COMBUSTIVEIS. Controle interno, nao editavel pelo cliente. */
  modelo_ia_empresa: string = "PADRAO";
}

export class IaScriptPrompt {
  id: number = 0;
  seller_id: number = null;
  seller_nome: string = "";
  chave: string = "";
  nome: string = "";
  prompt: string = "";
  ordem: number = 0;
  arquivo_url: string = null;
  arquivo_nome: string = null;
  arquivo_mime: string = null;
  link_url: string = null;
  link_titulo: string = null;

  /* CONTEUDO (resposta fixa) | CONHECIMENTO_PROPRIO (IA usa conhecimento geral, restrito a este topico) */
  tipo: string = "CONTEUDO";
  script_orientacao: string = null;
}

export class IaAprendizadoWhatsApp {
  total_aprovadas_sem_edicao: number = 0;
  total_editadas: number = 0;
  total_recusadas: number = 0;
  total_enviadas_auto: number = 0;
  total_handoff: number = 0;
  taxa_aprovacao_sem_edicao: number = 0;
  sugerir_modo_auto: boolean = false;
  dias_janela: number = 30;
  correcoes: IaCorrecaoResposta[] = [];
}

export class IaCorrecaoResposta {
  id: number = 0;
  pergunta: string = "";
  resposta_original: string = "";
  resposta_final: string = "";
  usuario_acao: string = "";
  data_acao: Date = null;
  status: string = "";
}

export class IaLacuna {
  pergunta: string = "";
  total: number = 0;
  ultima_data: Date = null;
}

export class IaWhatsAppPlano {
  id: number = 0;
  seller_id: number = null;
  seller_nome: string = "";
  nome: string = "";
  descricao: string = "";
  valor: number = 0;
  condicao: string = "";
  destaque: boolean = false;
  ativo: boolean = true;
  ordem: number = 0;
  link_pagamento: string = "";
}

export class IaPagamentosWhatsApp {
  configurado: boolean = false;
  cobrancas: IaCobrancaHistorico[] = [];
}

export class IaCobrancaHistorico {
  id: number = 0;
  created_at: Date = null;
  contato_nome: string = "";
  telefone: string = "";
  plano_nome: string = "";
  valor: number = 0;
  status_interno: string = "";
  payment_status: string = "";
  payment_method_id: string = "";
  installments: number = null;
  dt_pagamento: Date = null;
  whatsapp_oficial_atendimento_id: number = 0;
}

export class IaContextoRequest {
  guidclientenapis: string = "";
  client_id: number = 0;
  seller_id: number = 0;
  id_call_center_ligacao: number = null;
  origem: string = "CALL_CENTER";
}

export class IaChatRequest extends IaContextoRequest {
  pergunta: string = "";
}

export class IaResposta {
  sucesso: boolean = false;
  tipo: string = "";
  mensagem: string = "";
  resposta: string = "";
  modelo_ia: string = "";
  data_pesquisa: Date = null;
  contexto: IaContextoComercial = null;
  produtos_sugeridos: IaProdutoSugerido[] = [];
}

export class IaChatHistorico {
  id: number = 0;
  tipo: string = "";
  pergunta: string = "";
  resposta: string = "";
  status: string = "";
  data_criacao: Date = null;
}

export class IaContextoComercial {
  cliente: any = null;
  vendedor: any = null;
  ultimas_compras: any[] = [];
  condicoes_especiais: any[] = [];
  produtos_sugeridos: IaProdutoSugerido[] = [];
}

export class IaProdutoSugerido {
  product_id: number = 0;
  produto_nome: string = "";
  produto_codigo: string = "";
  total_vendido_segmento: number = 0;
  estoque_atual: number = 0;
  preco_lista: number = 0;
  preco_especial: number = null;
  qtd_minima: number = null;
  condicao_especial: string = "";
  argumento_venda: string = "";
  motivo: string = "";
  qtd_ultima_compra: number = null;
  preco_ultima_compra: number = null;
  data_ultima_compra: Date = null;
  numero_nf_ultima_compra: string = "";
  indicado_segmento: boolean = false;
  condicoes_especiais: IaCondicaoEspecial[] = [];
}

export class IaCondicaoEspecial {
  id_produto_especial: number = 0;
  id_produto_tabela_especial: number = 0;
  product_id: number = 0;
  tabela_especial_descricao: string = "";
  produto_nome: string = "";
  produto_codigo: string = "";
  preco_especial: number = 0;
  qtd_minima: number = null;
  tabelaespecial: boolean = false;
}
